import { AnonymousApplicationDto } from '../../application/dto/anonymous-application.dto';
import { ICountry } from '../../common';
import { IVisaType } from '../../visa-type';
import { IUser } from '../interface/i-user';

/**
 * Creates user objects
 */
export class IUserFactory {
  /**
   * Creates an object from a given anonymous application
   * @param dto
   * @returns
   */
  newFromAnonymousApplicationDto(
    dto: AnonymousApplicationDto,
    country: ICountry,
    visaType: IVisaType,
    visaSubType?: IVisaType,
  ): IUser {
    const contacts = dto.contactsDto.contacts;
    const { firstName, lastName } = dto.nameDto;
    const user = {
      contactInformation: contacts,
      firstName,
      lastName,
      candidate: {
        country: country,
        countryId: country.id,
        candidateVisa: {
          visaType: visaType,
          visaTypeId: visaType.id,
          visaSubType: visaSubType,
          visaSubTypeId: visaSubType ? visaSubType.id : undefined,
        },
      },
    } as IUser;
    return user;
  }
}
